import { AiOutlineTrophy } from 'react-icons/ai';
import moreMedal from 'src/app/images/more-medal.svg';
import FunctionCard from './FunctionCard';
import { PageCol, PageContent } from '@/components/custom/page';
import {
  MetricHat,
  MetricHeader,
  MetricHeaderLevel,
  MetricHeaderPoints,
  MetricHeaderStar,
  MetricHeaderTitle,
  MetricList,
  MetricNews,
  MetricNewsCard,
  MetricNewsCardCaption,
  MetricNewsCardContent,
  MetricNewsCardFigure,
  MetricNewsCardText,
  MetricNewsHeader,
  MetricNewsHeaderPoints,
  MetricNewsHeaderTitle,
  MetricSection
} from '@/components/custom/metric';
import { CardProgress, CardProgressBar, CardProgressContainer } from '@/components/ui/card';
import { AvatarWrapper } from '@/components/ui/avatar';

export default function StudentMetricsView({ achievements, milestones, achievementRanking }) {
  const dailyAchievements = achievements?.filter(item => {
    if (item.achievement.category === 'daily') {
      return true;
    }
  });

  const weeklyAchievements = achievements?.filter(item => {
    if (item.achievement.category === 'weekly') {
      return true;
    }
  });
  const meritAchievements = achievements?.filter(item => {
    if (item.achievement.category === 'merit') {
      return true;
    }
  });

  const porcentagem = milestones?.['milestone-level']?.['points-required'] ? (milestones.score / milestones['next-milestone-level']['points-required']) * 100 : 0;

  return (
    <PageContent className="flex flex-col !flex-nowrap gap-16 xl:flex-row">
      <PageCol
        bg
        className="gap-0"
      >
        <MetricHeader>
          <MetricHeaderLevel>
            <MetricHeaderTitle>
              <MetricHeaderStar isActive />
              Nível {milestones?.['milestone-level']?.['level-order'] ?? 1}
            </MetricHeaderTitle>
            <MetricHeaderTitle isDisabled>
              <MetricHeaderStar />
              Nível {milestones?.['next-milestone-level']?.['level-order'] ?? 2}
            </MetricHeaderTitle>
          </MetricHeaderLevel>

          <CardProgress className="w-full">
            <CardProgressContainer className="my-3">
              <CardProgressBar
                className="bg-[#6FCF97]"
                percentage={porcentagem}
              />
            </CardProgressContainer>
          </CardProgress>

          <MetricHeaderPoints>
            <b>{milestones?.score ?? 0}</b>/{milestones?.['next-milestone-level']?.['points-required'] ?? 500} pontos
          </MetricHeaderPoints>
        </MetricHeader>

        <MetricList>
          <MetricSection variant="conquest">
            <MetricHat>Conquistas Diárias</MetricHat>

            <MetricList space="sm">
              {dailyAchievements.map(item => {
                return (
                  <FunctionCard
                    title={item.achievement.title}
                    description={item.achievement.description}
                    done={item.done}
                    currentCount={item?.['stages-completed']}
                    totalCount={item.achievement?.['stages-count']}
                    points={item.achievement?.['base-score']}
                    buttonClass="achievements"
                  />
                );
              })}
            </MetricList>
          </MetricSection>

          <MetricSection variant="mission">
            <MetricHat>Missões da semana</MetricHat>

            <MetricList space="sm">
              {weeklyAchievements.map(item => {
                return (
                  <FunctionCard
                    title={item.achievement.title}
                    description={item.achievement.description}
                    done={item.done}
                    currentCount={item?.['stages-completed']}
                    totalCount={item.achievement?.['stages-count']}
                    points={item.achievement?.['base-score']}
                    buttonClass="missions"
                  />
                );
              })}
            </MetricList>
          </MetricSection>

          <MetricSection variant="merit">
            <MetricHat>Mérito</MetricHat>

            <MetricList space="sm">
              {meritAchievements.map(item => {
                return (
                  <FunctionCard
                    title={item.achievement.title}
                    description={item.achievement.description}
                    done={item.done}
                    currentCount={item?.['stages-completed']}
                    totalCount={item.achievement?.['stages-count']}
                    points={item.achievement?.['base-score']}
                    buttonClass="merit"
                  />
                );
              })}
            </MetricList>
          </MetricSection>
        </MetricList>
      </PageCol>

      <MetricNews>
        <MetricHat className="bg-primary-lightest text-primary">Evento mensal</MetricHat>

        <MetricNewsHeader>
          <MetricNewsHeaderTitle>{achievementRanking?.regional?.name}</MetricNewsHeaderTitle>

          <CardProgress className="w-full">
            <CardProgressContainer className="my-3">
              <CardProgressBar
                className="bg-[#6FCF97]"
                percentage={parseInt((achievementRanking?.['total-score'] * 100) / achievementRanking?.['required-score'])}
              />
            </CardProgressContainer>
          </CardProgress>

          <MetricNewsHeaderPoints>
            <span>
              {achievementRanking?.['total-score']} / {achievementRanking?.['required-score']} pts
            </span>
            <b>Ajude a GRE e ganhe 100pts</b>
          </MetricNewsHeaderPoints>
        </MetricNewsHeader>

        <MetricList space="sm">
          {achievementRanking?.['last-achievement-users'].map(item => {
            return (
              <MetricNewsCard>
                <MetricNewsCardContent>
                  <MetricNewsCardFigure>
                    <AvatarWrapper
                      size="sm"
                      src={item?.user?.image?.url}
                      text={item?.user?.name}
                    />
                    <MetricNewsCardCaption>Nível {item?.['milestone-level']?.['level-order']}</MetricNewsCardCaption>
                  </MetricNewsCardFigure>

                  <MetricNewsCardText>
                    <b>{item?.user?.name}</b> ganhou <b>{item?.achievement?.['base-score']} pts</b> na missão <b>{item?.achievement?.['title']}</b>
                  </MetricNewsCardText>
                </MetricNewsCardContent>

                <div className="medal medal--sm">
                  <img
                    src={moreMedal}
                    alt="nova medalha"
                    className="medal__img"
                  />
                  <span className="medal__value">
                    <AiOutlineTrophy />
                  </span>
                </div>
              </MetricNewsCard>
            );
          })}
        </MetricList>
      </MetricNews>
    </PageContent>
  );
}
